exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-4e475405] {\n  padding-right: 0.85rem;\n}\n.small-text[data-v-4e475405] {\n  font-size: 0.75rem;\n  font-weight: 600;\n}", ""]);

// exports
